import * as React from "react";
import type { SVGProps } from "react";
const SvgMobilepay = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    width="100%"
    height="100%"
    {...props}
  >
    <path
      fill="#5a78ff"
      fillRule="evenodd"
      d="M9.68 2.13a1.68 1.68 0 0 1 2.082.677c.088.136.144.288.2.44a417 417 0 0 1 1.26 3.048c1.11-.423 2.267-.742 3.457-.806.43-.016.87-.008 1.3.04.415.981.806 1.971 1.221 2.945.682.245 1.358.411 1.995.782v6.033c-1.436-.774-3.088-1.077-4.708-1.117.367.886.734 1.78 1.101 2.665.088.216.192.423.224.647a1.7 1.7 0 0 1-.455 1.476 1.65 1.65 0 0 1-.575.383c-2.067.854-4.126 1.716-6.193 2.562a1.7 1.7 0 0 1-1.54-.216 1.7 1.7 0 0 1-.575-.726C6.56 16.35 4.652 11.73 2.736 7.117c-.095-.231-.2-.463-.223-.71a1.69 1.69 0 0 1 .718-1.58c.176-.128.391-.2.59-.288 1.956-.79 3.903-1.604 5.858-2.41m.327.853C8.074 3.78 6.151 4.578 4.22 5.376c-.128.056-.264.104-.391.168a.78.78 0 0 0-.4.758c.017.16.096.303.152.455 1.916 4.629 3.839 9.257 5.754 13.886.16.383.655.575 1.03.391 2.035-.838 4.062-1.684 6.097-2.522.375-.144.59-.614.439-.99-.455-1.109-.918-2.21-1.365-3.32-1.466.043-2.983.383-4.27 1.094-.81-1.993-1.66-3.97-2.457-5.97.965-1.157 2.226-2.05 3.59-2.673a.5.5 0 0 0-.031-.096c-.447-1.07-.886-2.13-1.325-3.2-.175-.367-.662-.559-1.037-.375"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgMobilepay;
